import firebase from 'firebase'
import config from 'config'

// firebase.database.enableLogging(true, true)
firebase.database.enableLogging(false, false)
firebase.initializeApp(config)

export const ref = firebase.database().ref()
export const auth = firebase.auth()
export const storage = firebase.storage()
export const storageRef = storage.ref()



// WEBPACK FOOTER //
// ./src/constants/firebase.js